var render = function () {
  var _vm$currentRound$cont, _vm$currentRound, _vm$currentRound$cont2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("label-maker-activity " + (_vm.keyboardEnabled ? '' : 'full-height')),
      "customContentContainerStyles": {
        minWidth: '100%',
        width: 'max-content'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions", null, {
    "onVoiced": _vm.handleOnInstructionsVoiced
  })], 2), _c('section', {
    staticClass: "label-maker-container",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('section', {
    staticClass: "draggable-words-container"
  }, _vm._l(_vm.currentRound.steps, function (step, index) {
    return _c('div', {
      key: step.id,
      staticClass: "label-word",
      class: ("image step-" + (step.id)),
      attrs: {
        "aria-label": ("label for " + (step.answer)),
        "aria-pressed": "false",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnLabelWordEnterEvent(("step-" + (step.id)));
        }
      }
    }, [_c('svg', {
      staticClass: "border-style",
      style: _vm.cardBorder,
      attrs: {
        "height": "46px",
        "width": "220px"
      }
    }), !_vm.finishedSteps.some(function (_ref) {
      var id = _ref.id;
      return id === step.id;
    }) ? _c('p', [_vm._v(_vm._s(step.answer))]) : _c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": index
      }
    })], 1);
  }), 0), _c('section', {
    staticClass: "label-drop-zone-container",
    style: {
      backgroundImage: ("url(" + ((_vm$currentRound$cont = (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$cont2 = _vm$currentRound.contentImage) === null || _vm$currentRound$cont2 === void 0 ? void 0 : _vm$currentRound$cont2.image.src) !== null && _vm$currentRound$cont !== void 0 ? _vm$currentRound$cont : '') + ")")
    }
  }, _vm._l(_vm.currentRound.steps, function (step) {
    return _c('div', {
      key: step.id,
      staticClass: "label-word-white focusable",
      class: ("image step-" + (step.id)),
      style: {
        left: ((step.position.x - 110) + "px"),
        top: ((step.position.y - 130) + "px")
      },
      attrs: {
        "aria-label": ("label answer for " + (step.answer))
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnLabelWordWhiteEnterEvent(("step-" + (step.id)));
        }
      }
    }, [_c('div', {
      staticClass: "label-word-position"
    }, [_c('svg', {
      staticClass: "border-style-white",
      style: _vm.cardBorderWhite,
      attrs: {
        "height": "46px",
        "width": "220px"
      }
    }), _c('p', [_vm._v(_vm._s(step.answer.slice(0, 1)))])])]);
  }), 0)])], 2), _c('article', {
    style: {
      display: _vm.keyboardEnabled ? 'block' : 'none'
    }
  }, [_vm._t("keyboard")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }